<script>
  import Layout from "../../Layout/Layout.svelte";
  import config from "../../stores/config";
  import axios from "axios";
  import { onMount } from "svelte";
  import OrderRow from "./OrderRow.svelte";
  import { Circle } from "svelte-loading-spinners";
  import MenuHeading from "../../shared/MenuHeading.svelte";
  import Select from "svelte-select";
  import * as ls from "local-storage";
  import { link } from "svelte-spa-router";

  let orders = null;
  let queryURL = "";
  let dateLabel;

  /* Query Parameters, just CHANGE them and the query will be regenerated as well, NO need to change everything */
  let page = 1;
  let searchKey = "";
  let ordered; // today|this-week|this-month|last-two-months|this-year nothing
  let completed; // completed=true or nothing

  const fetchOrders = () => {
    orders = null;

    queryURL = `${$config.backendURL}/orders/page/${page}?`;
    queryURL += `&searchKey=${searchKey || ""}`;
    if (ordered) queryURL += `&ordered=${ordered || ""}`;
    if (completed) queryURL += `&completed=${completed || ""}`;

    axios
      .get(queryURL, { headers: { authorization: ls.get("jwt") } })
      .then((res) => {
        orders = res.data;
        // console.log(orders);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handlePrevPage = () => {
    if (page <= 1) page = 1;
    else {
      page = page - 1;
      fetchOrders();
    }
  };
  const handleNextPage = () => {
    if (page <= 0) page = 0;
    page = page + 1;
    fetchOrders();
  };

  const handleRefresh = () => {
    page = 1;
    searchKey = null;
    ordered = null;
    completed = null;
    dateLabel = "";
    fetchOrders();
  };

  onMount(() => {
    fetchOrders();
  });
</script>

<svelte:head>
  <title>Orders | Fabi CC System</title>
</svelte:head>

<Layout>
  <MenuHeading
    title={`${dateLabel || ""} ${completed ? "Closed Orders" : "Open Orders"} `}
    description="Manage Orders Here..."
  />

  <!-- Search Bar -->
  <div class="flex justify-between">
    <div class="flex justify-center">
      <input
        bind:value={searchKey}
        on:input={fetchOrders}
        class="shadow-sm"
        type="text"
        placeholder="Search Here..."
      />
      <button class="ml-2 btn btn-green" on:click={fetchOrders}>
        <i class="fas fa-search" />
      </button>
    </div>
    <div class="flex justify-center">
      <a use:link href="/addorder" class="btn btn-red mr-3">
        New Order
        <i class="fas fa-plus-circle ml-3" />
      </a>
      <button class="btn btn-blue-outline" on:click={handleRefresh}>
        Refresh Page
        <i class="fas fa-undo ml-3" />
      </button>
    </div>
  </div>

  <div class="flex justify-between mt-6 flex-row-reverse">
    <div class="flex items-center">
      <div class="mr-4 flex items-center text-gray-400">
        Choose a Time:
        <i class="fas fa-clock ml-2" />
      </div>
      <div class="w-64 shadow-sm rounded-sm">
        <Select
          items={[
            { label: "Today", value: "today" },
            { label: "This Week", value: "this-week" },
            { label: "This Month", value: "this-month" },
            { label: "Past Two Months", value: "last-two-months" },
            { label: "This Year", value: "this-year" },
            { label: "All Time", value: "all" },
          ]}
          selectedValue={ordered}
          on:select={(e) => {
            if (e.detail.value == "all") {
              ordered = null;
              dateLabel = "";
            } else {
              ordered = e.detail.value;
              dateLabel = `${e.detail.label}: `;
            }
            fetchOrders();
          }}
        />
      </div>
    </div>

    <div class="flex items-center">
      <button
        class="btn btn-green-outline mr-4 uppercase"
        on:click={() => {
          ordered = "today";
          fetchOrders();
        }}
      >
        <i class="fas fa-chevron-circle-down mr-3" />
        TODAY'S ORDERS
      </button>
      <button
        class="btn btn-blue-outline mr-4 uppercase"
        on:click={() => {
          completed = true;
          fetchOrders();
        }}
      >
        <i class="fas fa-check-circle mr-3" />
        Closed
      </button>
      <button
        class="btn btn-red-outline mr-4 uppercase"
        on:click={() => {
          completed = null;
          fetchOrders();
        }}
      >
        <i class="fas fa-exclamation-circle mr-3" />
        Open
      </button>
    </div>
  </div>

  <!-- Orders Bar -->
  <div
    class="mt-6 bg-white rounded-md shadow-sm w-full overflow-auto text-gray-500 text-sm"
  >
    <div
      class="th tracking-wider border-b border-gray-100 font-semibold text-gray-600"
    >
      <div style="min-width: 11rem; max-width: 11rem;">Actions</div>
      <div style="min-width: 7rem; max-width: 7rem;">Reference #</div>
      <div style="min-width: 10rem; max-width: 10rem;">Open On</div>
      <div style="min-width: 15rem; max-width: 15rem;">Delivery Estimation</div>
      <div style="min-width: 7rem; max-width: 7rem;">Status</div>
      <div style="min-width: 8.5rem; max-width: 8.5rem;">Closed On</div>
      <div style="min-width: 27.5rem; max-width: 27.5rem;">Customer</div>
    </div>

    {#if orders}
      {#each orders as order (order._id)}
        <OrderRow {...order} on:delete={fetchOrders} />
      {:else}
        <div class="h-52 w-full flex items-center justify-center">
          Nothing to show...
        </div>
      {/each}
    {:else}
      <div class="h-52 w-full flex items-center justify-center">
        <Circle size="50" color="rgb(16, 185, 129)" unit="px" />
      </div>
    {/if}

    <div class="tf">
      <button class="text-base btn btn-gray-outline" on:click={handlePrevPage}>
        <i class="fas fa-arrow-circle-left mr-3" />
        Prev Page
      </button>
      <div class="mx-4">Page {page}</div>
      <button class="text-base btn btn-gray-outline" on:click={handleNextPage}>
        Next Page
        <i class="fas fa-arrow-circle-right ml-3" />
      </button>
    </div>
  </div>
</Layout>

<style>
  .th,
  .tf {
    display: flex;
    align-items: center;
    width: max-content;
    padding: 20px;
  }
</style>
